import React, { lazy, Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { useAppSelector } from 'hooks/useStore';

// const Landing = lazy(() => import('pages/public/Landing'));
// const Courses = lazy(() => import('pages/public/Courses'));
// const CourseInfo = lazy(() => import('pages/public/CourseInfo'));
// const FullSATLevelTest = lazy(() => import('pages/public/FullSATLevelTest'));
// const Profile = lazy(() => import('pages/private/Profile'));
// const Classroom = lazy(() => import('pages/private/Classroom'));
// const Course = lazy(() => import('pages/private/Course'));
// const Test = lazy(() => import('pages/private/Test'));
// const TestReport = lazy(() => import('pages/private/TestReport'));
// const Cart = lazy(() => import('pages/private/Cart'));
// const Checkout = lazy(() => import('pages/private/Checkout'));
// const PaymentConfirm = lazy(() => import('pages/private/PaymentConfirm'));
// const StripeConfirm = lazy(() => import('pages/private/PaymentConfirm/StripeConfirm'));
// const Quiz = lazy(() => import('pages/private/Quiz'));
// const QuizResult = lazy(() => import('pages/private/Quiz/Result'));

import Landing from 'pages/public/Landing';
import Register from 'pages/public/Register';
import Courses from 'pages/public/Courses';
import SAT from 'pages/public/Tests/SAT';
import PSAT from 'pages/public/Tests/PSAT';
import ACT from 'pages/public/Tests/ACT';
import DailyQuestion from 'pages/public/DailyQuestion';
// import CourseInfo from 'pages/public/CourseInfo';
import FullSATLevelTest from 'pages/public/FullSATLevelTest';
import Profile from 'pages/private/Profile';
import Classroom from 'pages/private/Classroom';
import Course from 'pages/private/Course';
import Test from 'pages/private/Test';
import Digital from 'pages/private/Digital';
import DigitalACT from 'pages/private/DigitalACT';
import DigitalACTReport from 'pages/private/DigitalACT/DigitalACTReport';
import DigitalACTReview from 'pages/private/DigitalACT/DigitalACTReview';
import DigitalReport from 'pages/private/DigitalReport';
import PersonalizedPlan from 'pages/private/PersonalizedPlan';
import DigitalReview from 'pages/private/DigitalReview';
import TestReport from 'pages/private/TestReport';
import TestFinder from 'pages/private/TestFinder';
import TestFinderTest from 'pages/private/TestFinderTest';
import TestFinderReview from 'pages/private/TestFinderReview';
import Cart from 'pages/private/Cart';
import Checkout from 'pages/private/Checkout';
import PaymentConfirm from 'pages/private/PaymentConfirm';
import StripeConfirm from 'pages/private/PaymentConfirm/StripeConfirm';
import Quiz from 'pages/private/Quiz';
import QuizResult from 'pages/private/QuizResult';
import QuizReview from 'pages/private/QuizReview';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';
import KatexTester from 'pages/test/KatexTester';

function PrivateRoutes() {
    const { bundles, courses, tests } = useAppSelector(state => state.cart);
    const { status } = useAppSelector(state => state.error);
    
    const { state } = useLocation() as {
        state?: { referrer?: string; }
    };

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path='/' element={<Landing />} />
                 <Route path='/courses'>
                    {/* <Route path='' element={<Classroom />} /> */}
                    <Route path='' element={<Courses />} />
                    <Route path='report/:testId' element={<TestReport />} />
                    <Route path=':courseUrl'>
                        <Route path='' element={<Course />} />
                        <Route path='quiz/:quizNum' element={<Quiz />} />
                        <Route path='quiz/:quizNum/result' element={<QuizResult />} />
                        <Route path='quiz/:quizNum/review' element={<QuizReview />} />
                    </Route>
                </Route>
                <Route path='/account' element={<Profile />} />
                <Route path='/register' element={<Register />} />
                {/* <Route path='/courses'>
                    <Route path='' element={<Courses />} />
                    <Route path='report/:testId' element={<TestReport />} />
                </Route> */}
                <Route path='/tests/digital-sat' element={<SAT />} />
                <Route path='/tests/digital-psat' element={<PSAT />} />
                <Route path='/tests/digital-act' element={<ACT />} />
                <Route path='/daily-question' element={<DailyQuestion />} />
                {/* <Route path='/course'>
                    <Route path=':courseUrl' element={<CourseInfo />} />
                </Route> */}
                <Route path='/tests/personalizedPlan' element={<PersonalizedPlan />} />
                <Route path='/level-test' element={<Navigate to='/tests/digital-sat' />} />
                <Route path='/test-finder' element={<TestFinder />} />
                <Route path='/test-finder/test' element={<TestFinderTest />} />
                <Route path='/sat-or-act' element={<TestFinder />} />
                <Route path='/test/:testId' element={<Test />} />
                <Route path='/digital/:testId' element={<Digital />} />
                <Route path='/digital-act/:testId' element={<DigitalACT />} />
                <Route path='/report/digital-sat/:testId' element={<DigitalReport />} />
                <Route path='/report/digital-act/:testId' element={<DigitalACTReport />} />
                <Route path='/review/digital-sat/:testId' element={<DigitalReview />} />
                <Route path='/review/digital-act/:testId' element={<DigitalACTReview />} />
                <Route path='/review/test-finder/:testId' element={<TestFinderReview />} />
                <Route path='/cart' element={<Cart />} />
                <Route path='/checkout' element={courses.length + tests.length + bundles.length > 0 
                    ? <Checkout /> 
                    : <Navigate to='/cart' replace />
                } />
                <Route path='/payment/stripe' element={<StripeConfirm />} />
                <Route path='/payment/:paymentId' element={<PaymentConfirm />} />

                <Route path='/sign-in' element={<Navigate to={state?.referrer
                    ? state.referrer
                    : '/'
                } replace />} />
                <Route path='/sign-up' element={<Navigate to={state?.referrer
                    ? state.referrer
                    : '/'
                } replace />} />
                <Route path='/onboarding' element={<Navigate to={state?.referrer
                    ? state.referrer
                    : '/'
                } replace />} />
                {/* <Route path='/sign-up' element={<Navigate to='/' replace />} />
                <Route path='/onboarding' element={<Navigate to='/' replace />} />
                <Route path='/password-reset' element={<Navigate to='/' replace />} /> */}

                {!+process.env.PRODUCTION && <Route path='katex' element={<KatexTester />} />}

                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PrivateRoutes;
